import * as React from 'react'

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { History } from 'history'

import Screens from './Screens'

import useReducer from '@store/useReducer'
import * as AccountStore from '@store/account/account'
import * as AuthStore from '@store/auth/auth'

import OAuthConfig from '@app/config'
import oauth from '@utils/OAuth2'

import Menu from '@components/adminMenu/Menu'
import Cgus from '@components/cgus/Cgus'
import Modal from '@components/modal/Modal'

import apis from '@app/api/api'
import Logger from '@utils/Logger'

const enhanceNavigator = (h: History): Navigation => {
  return {
    push: h.push,
    goBack: h.goBack,
    navigate: h.push,
    replace: h.replace,
  }
}

const MainLayout = () => {
  const account = useReducer(AccountStore.store, (s) => s.account)
  const tokens = useReducer(AuthStore.store, (s) => s.OAuth)
  const has_accept_cgu = useReducer(AuthStore.store, (s) => s.has_accept_cgu)
  const [cgus, setCgus] = React.useState<Cgu>()

  const isConnected = !!account && !!tokens

  React.useEffect(() => {
    if (!!account && !!tokens) {
      apis.user
        .login()
        .then((user) => AccountStore.actions.connectUser({ ...user, authmode: tokens.auth_mode }))
        .catch((err) => {
          AuthStore.actions.resetTokens()
          Logger.info('ERROR ON LOGGING CURRENT USER : ', err)
        })
    }
  }, [])

  React.useEffect(() => {
    if (!!tokens?.access_token) {
      apis.user.getCgus().then(setCgus)
    }
  }, [tokens?.access_token])

  React.useEffect(() => {
    if (!!cgus && !!cgus.content && account?.authmode === 'EXTERNAL') {
      Modal.open(() => <Cgus closeModal={Modal.close} cgus={cgus.content} />)
    }
  }, [has_accept_cgu, cgus])

  if (tokens && tokens.expire_at < new Date().getTime()) {
    AuthStore.actions.resetTokens()
  }

  return (
    <Router key={`stack-${!!isConnected ? 'ckcc' : 'login'}`}>
      <Route path="/">
        {({ history }) => {
          const navigation = enhanceNavigator(history)
          return (
            <Switch>
              {Screens.filter((s) => s.authenticated === isConnected).map((scr) => {
                return (
                  <Route path={scr.path} exact key={scr.name}>
                    {({ history, match, location }) => {
                      const matchParams = match && match.params ? match.params : {}
                      const params = history.location.state || {}

                      //Connexion de l'utilisateur
                      const code_url = location.search.split('code=')[1]
                      const code = code_url && code_url.split('&')[0]

                      //Vérification si utilisateur connecté
                      const connected = AuthStore.store.getState().OAuth

                      if (
                        connected &&
                        location.pathname === OAuthConfig.AUTH_CONFIG[connected.auth_mode].logoutRedirectUrl
                      ) {
                        oauth.reset()
                      }

                      const mode: AuthMode | undefined =
                        window.location.href.startsWith(OAuthConfig.AUTH_CONFIG['INTERNAL'].loginUrl) &&
                        window.location.pathname === OAuthConfig.AUTH_CONFIG.INTERNAL.redirectUrl
                          ? 'INTERNAL'
                          : location.pathname === OAuthConfig.AUTH_CONFIG.EXTERNAL.redirectUrl &&
                            window.location.href.startsWith(OAuthConfig.AUTH_CONFIG['EXTERNAL'].loginUrl)
                          ? 'EXTERNAL'
                          : undefined

                      const authInfo = mode && code && { mode, code }

                      return (
                        <>
                          <scr.screen
                            navigation={navigation}
                            screen={scr.name}
                            {...params}
                            {...matchParams}
                            {...{ authInfo }}
                            {...scr.props}
                          />
                          {connected && <Menu navigation={navigation} current={scr.path} />}
                        </>
                      )
                    }}
                  </Route>
                )
              })}
              <Redirect to="/" />
            </Switch>
          )
        }}
      </Route>
    </Router>
  )
}

export default MainLayout
